﻿$.fn.dxCtrlWizardItem4ResaReglement = function custom_dxCtrlWizardItem4ResaReglement(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlwizarditem4resareglement dx-ctrl");
        this.createInstance(new cdxCtrlWizardItem4ResaReglement(this, option));
    }
    return this;
}

window.cdxCtrlWizardItem4ResaReglement = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var mtArrhes = null
    var $DivLstReg = null
    var dxCb = null
    var dxVirement = null
    var dxCheque = null
    var dxChqVac = null
    function mConstruit() {
        container.empty()

        container.css("padding", "20px")

        $("<div style='text-align:center;font-weight:bold;font-size:140%;padding-bottom:20px;'>Choisissez votre mode de règlement</div>").appendTo(container)

        var totTtc = option.bddCtrl.getObjet(option.dataForResa.dataReservation).objetMetier.mGetTotalTtc()
        mtArrhes = option.bddCtrl.getObjet(option.dataForResa.dataReservation).objetMetier.mGetCalculMtArrhes()
        var $Div = $("<div style='text-align:right'></div>").appendTo(container)
        $("<div></div>").appendTo($Div).html("<span>Total TTC: </span><span style='font-size:140%;'>" + parseFloat(totTtc).formatDisplay() + "€</span>")
        $("<div></div>").appendTo($Div).html("<span>Montant des arrhes à régler: </span><span style='font-weight:bold;font-size:140%;'>" + mtArrhes.formatDisplay() + "€</span>")

        $("<div style='padding:20px 0 10px 0;'>Pour confirmer votre réservation, vous devez régler la somme de <b>" + mtArrhes.formatDisplay() + "€</b> par un des modes de règlement ci-dessous:</div>").appendTo(container)


        $DivLstReg = $("<div style='padding-left:20px;'/>").appendTo(container)
        var isSelected = false
        var disableChangeValue = false
        dxCb = null
        var $DivCb = null
        if (option.bddCtrl.paraAppli.mGetPara("hebergement_mode_reglement_arrhes").contains(1) && option.bddCtrl.mGetArray("societe")[0].has_cle_stripe == "1") {
            dxCb = $("<div/>").appendTo($DivLstReg).dxRadioGroup({
                dataSource: ["Règlement par carte bancaire"],
                value: "Règlement par carte bancaire",
                onValueChanged: function (e) {
                    if (disableChangeValue) return
                    disableChangeValue = true
                    if (dxVirement) dxVirement.option("value", "")
                    if (dxCheque) dxCheque.option("value", "")
                    if (dxChqVac) dxChqVac.option("value", "")
                    $DivCb.slideDown(300)
                    if ($DivVirement) $DivVirement.slideUp(300)
                    if ($DivCheque) $DivCheque.slideUp(300)
                    if ($DivChqVac) $DivChqVac.slideUp(300)
                    disableChangeValue = false
                }
            }).dxRadioGroup("instance")

            $DivCb = $("<div style='padding:0px 10px 20px 32px;'/>").appendTo($DivLstReg)

            var $Table = $("<table style='width:100%'/>").appendTo($DivCb)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:1px;font-size:60px;vertical-align:top;padding-right:10px;'/>").appendTo($Tr)
            $("<i class='fas fa-credit-card'></i>").appendTo($Td)

            var $Td = $("<td style='width:100%;' class='linkconfirmreg'/>").appendTo($Tr)
            var $A = $("<a href='javascript:void(0)'>Je choisis de régler la somme de <b>" + mtArrhes.formatDisplay() + "</b>€ par carte bancaire</a>").appendTo($Td)
            $A.on("click", function (e) {
                mExeReglement(1)
            })
            $("<div style='padding:5px 0;font-style:italic;font-size:80%;line-height:1;'>Aprés règlement, votre réservation sera confirmée dans notre planning et vous recevrez un email de confirmation</div>").appendTo($Td)
            isSelected = true
        }

        dxVirement = null
        var $DivVirement = null
        if (option.bddCtrl.paraAppli.mGetPara("hebergement_mode_reglement_arrhes").contains(2)) {
            dxVirement = $("<div/>").appendTo($DivLstReg).dxRadioGroup({
                dataSource: ["Règlement par virement"],
                value: (isSelected ? "" : "Règlement par virement"),
                onValueChanged: function (e) {
                    if (disableChangeValue) return
                    disableChangeValue = true
                    if (dxCb) dxCb.option("value", "")
                    if (dxCheque) dxCheque.option("value", "")
                    if (dxChqVac) dxChqVac.option("value", "")
                    $DivVirement.slideDown(300)
                    if ($DivCb) $DivCb.slideUp(300)
                    if ($DivCheque) $DivCheque.slideUp(300)
                    if ($DivChqVac) $DivChqVac.slideUp(300)
                    disableChangeValue = false
                }
            }).dxRadioGroup("instance")

            $DivVirement = $("<div style='padding:0px 10px 20px 32px;" + (!isSelected ? "" : "display:none") + "'/>").appendTo($DivLstReg)

            var $Table = $("<table style='width:100%'/>").appendTo($DivVirement)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:1px;font-size:60px;vertical-align:top;padding-right:10px;'/>").appendTo($Tr)
            $("<i class='fas fa-money-bill-transfer'></i>").appendTo($Td)

            var $Td = $("<td style='width:100%;' class='linkconfirmreg'/>").appendTo($Tr)
            var $A = $("<a href='javascript:void(0)'>Je choisis de régler la somme de <b>" + mtArrhes.formatDisplay() + "</b>€ par virement</a>").appendTo($Td)
            $A.on("click", function (e) {
                mExeReglement(2)
            })

            if (option.bddCtrl.paraAppli.mGetPara("hebergement_temps_attente_arrhes") == 0) {
                $("<div style='padding:5px 0;font-style:italic;font-size:80%;line-height:1;'>En choisissant le règlement par virement, votre réservation sera confirmée en attente d'arrhes dans notre planning et vous recevrez un email de confirmation à réception des arrhes.</div>").appendTo($Td)
            } else {
                var dateEnd = (new Date()).addDays(option.bddCtrl.paraAppli.mGetPara("hebergement_temps_attente_arrhes"))
                $("<div style='padding:5px 0;font-style:italic;font-size:80%;line-height:1;'>Suite à la validation de votre règlement par virement, votre réservation sera enregistrée dans notre planning, en attente de réception des arrhes. Un email de confirmation vous sera adressé.<br/>Votre réservation sera maintenue jusqu’au " + dateEnd.toDDMMAA() + " au soir. Passé ce délai, et sans réception des arrhes, celle-ci sera automatiquement annulée.</div>").appendTo($Td);
            }

            isSelected = true
        }

        dxCheque = null;
        var $DivCheque = null
        if (option.bddCtrl.paraAppli.mGetPara("hebergement_mode_reglement_arrhes").contains(3)) {
            dxCheque = $("<div/>").appendTo($DivLstReg).dxRadioGroup({
                dataSource: ["Règlement par chèque"],
                value: (isSelected ? "" : "Règlement par chèque"),
                onValueChanged: function (e) {
                    if (disableChangeValue) return
                    disableChangeValue = true
                    if (dxCb) dxCb.option("value", "")
                    if (dxVirement) dxVirement.option("value", "")
                    if (dxChqVac) dxChqVac.option("value", "")
                    $DivCheque.slideDown(300)
                    if ($DivCb) $DivCb.slideUp(300)
                    if ($DivVirement) $DivVirement.slideUp(300)
                    if ($DivChqVac) $DivChqVac.slideUp(300)
                    disableChangeValue = false
                }
            }).dxRadioGroup("instance")

            $DivCheque = $("<div style='padding:0px 10px 20px 32px;" + (!isSelected ? "" : "display:none") + "'/>").appendTo($DivLstReg)

            var $Table = $("<table style='width:100%'/>").appendTo($DivCheque)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:1px;font-size:60px;vertical-align:top;padding-right:10px;'/>").appendTo($Tr)
            $("<i class='fas fa-money-check-dollar'></i>").appendTo($Td)

            var $Td = $("<td style='width:100%;' class='linkconfirmreg'/>").appendTo($Tr)
            var $A = $("<a href='javascript:void(0)'>Je choisis de régler la somme de <b>" + mtArrhes.formatDisplay() + "</b>€ par chèque</a>").appendTo($Td)
            $A.on("click", function (e) {
                mExeReglement(3)
            })

            if (option.bddCtrl.paraAppli.mGetPara("hebergement_temps_attente_arrhes") == 0) {
                $("<div style='padding:5px 0;font-style:italic;font-size:80%;line-height:1;'>En choisissant le règlement par chèque, votre réservation sera confirmée en attente d'arrhes dans notre planning et vous recevrez un email de confirmation à réception des arrhes.</div>").appendTo($Td)
            } else {
                var dateEnd = (new Date()).addDays(option.bddCtrl.paraAppli.mGetPara("hebergement_temps_attente_arrhes"))
                $("<div style='padding:5px 0;font-style:italic;font-size:80%;line-height:1;'>Suite à la validation de votre règlement par chèque, votre réservation sera enregistrée dans notre planning, en attente de réception des arrhes. Un email de confirmation vous sera adressé.<br/>Votre réservation sera maintenue jusqu’au " + dateEnd.toDDMMAA() + " au soir. Passé ce délai, et sans réception des arrhes, celle-ci sera automatiquement annulée.</div>").appendTo($Td);
            }

            isSelected = true
        }

        dxChqVac = null
        var $DivChqVac = null
        if (option.bddCtrl.paraAppli.mGetPara("hebergement_mode_reglement_arrhes").contains(5)) {
            dxChqVac = $("<div/>").appendTo($DivLstReg).dxRadioGroup({
                dataSource: ["Règlement par chèque vacances"],
                value: (isSelected ? "" : "Règlement par chèque vacances"),
                onValueChanged: function (e) {
                    if (disableChangeValue) return
                    disableChangeValue = true
                    if (dxCb) dxCb.option("value", "")
                    if (dxVirement) dxVirement.option("value", "")
                    if (dxCheque) dxCheque.option("value", "")
                    $DivChqVac.slideDown(300)
                    if ($DivCb) $DivCb.slideUp(300)
                    if ($DivVirement) $DivVirement.slideUp(300)
                    if ($DivCheque) $DivCheque.slideUp(300)
                    disableChangeValue = false
                }
            }).dxRadioGroup("instance")

            $DivChqVac = $("<div style='padding:0px 10px 20px 32px;" + (!isSelected ? "" : "display:none") + "'/>").appendTo($DivLstReg)

            var $Table = $("<table style='width:100%'/>").appendTo($DivChqVac)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:1px;font-size:60px;vertical-align:top;padding-right:10px;'/>").appendTo($Tr)
            $("<i class='fafa fafa-ancv'></i>").appendTo($Td)

            var $Td = $("<td style='width:100%;' class='linkconfirmreg'/>").appendTo($Tr)
            var $A = $("<a href='javascript:void(0)'>Je choisis de régler la somme de <b>" + mtArrhes.formatDisplay() + "</b>€ par chèque vacances</a>").appendTo($Td)
            $A.on("click", function (e) {
                mExeReglement(5)
            })

            if (option.bddCtrl.paraAppli.mGetPara("hebergement_temps_attente_arrhes") == 0) {
                $("<div style='padding:5px 0;font-style:italic;font-size:80%;font-style:italic;font-size:80%;line-height:1;'>En choisissant le règlement par chèque, votre réservation sera confirmée en attente d'arrhes dans notre planning et vous recevrez un email de confirmation à réception des arrhes.</div>").appendTo($Td)
            } else {
                var dateEnd = (new Date()).addDays(option.bddCtrl.paraAppli.mGetPara("hebergement_temps_attente_arrhes"))
                $("<div style='padding:5px 0;font-style:italic;font-size:80%;line-height:1;'>Suite à la validation de votre règlement par chèque vacances, votre réservation sera enregistrée dans notre planning, en attente de réception des arrhes. Un email de confirmation vous sera adressé.<br/>Votre réservation sera maintenue jusqu’au " + dateEnd.toDDMMAA() + " au soir. Passé ce délai, et sans réception des arrhes, celle-ci sera automatiquement annulée.</div>").appendTo($Td);
            }

            isSelected = true
        }

        $("<div style='font-style:italic;font-size:90%;line-height:1;padding-top:30px;'/>").appendTo(container).text(option.bddCtrl.paraAppli.mGetPara("hebergement_politique_arrhes"))

        var $Table = $("<table style='width:calc(100% - 40px);margin:20px 20px 0 20px;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;white-space:nowrap;'/>").appendTo($Tr)
        var $AAddHeberg = $("<a href='javascript:void(0)'>← Vos coordonnées</a>").appendTo($Td)
        $AAddHeberg.on("click", function (e) {
            option.onPrevious()
        })
        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        var $Td = $("<td style='width:1px;white-space:nowrap;'/>").appendTo($Tr)
        //var $AAddHeberg = $("<a href='javascript:void(0)'></a>").appendTo($Td)
        //$AAddHeberg.on("click", function (e) {
        //    option.onNext()
        //})
    }

    var isPayed = false
    function mExeReglement(idModeReglement) {
        jaugeDemarrage.mShow()

        //save contact
        if (option.dataForResa.clDataSaisie.mIsCoordonneDifferenteWithTemplate(option.dataForResa.dataReservation.id_table_destinataire, option.dataForResa.dataReservation.id_destinataire)) {
            option.bddCtrl.mAjaxCall({
                command: "savecontactwithdatasaisie",
                datatemplate: option.dataForResa.clDataSaisie.dataTemplate,
                datasaisie: option.dataForResa.clDataSaisie.data,
                id_reservation: option.dataForResa.dataReservation.id_reservation
            }, function (data) {
                option.dataForResa.dataReservation.id_table_destinataire = data.lstdatatemplate[0].id_table_key
                option.dataForResa.dataReservation.id_destinataire = data.lstdatatemplate[0].id_key
                mDemandeReglement()
            })
        } else {
            option.dataForResa.dataReservation.id_table_destinataire = option.dataForResa.clDataSaisie.dataTemplate.id_table_key
            option.dataForResa.dataReservation.id_destinataire = option.dataForResa.clDataSaisie.dataTemplate.id_key
            option.bddCtrl.getObjet(dataReservation).mSave(function () {
                mDemandeReglement()
            })
        }

        function mDemandeReglement() {
            var obj = option.bddCtrl.getObjet(option.dataForResa.dataReservation)
            var dataReservationArrhes = obj.objetMetier.mGetDataReservationArrhesFirst()
            dataReservationArrhes.mt = mtArrhes
            option.bddCtrl.getObjet(dataReservationArrhes).mSaveChamp("mt", function () {
                switch (parseInt(idModeReglement)) {
                    case 1: //cb
                        jaugeDemarrage.mHide()
                        $("<div/>").appendTo("body").dxCtrlPageSaisieCb({
                            bddCtrl: option.bddCtrl,
                            amount100: mtArrhes * 100,
                            id_societe: option.bddCtrl.mGetArray("societe")[0].id_societe,
                            id_table: option.bddCtrl.getObjet(dataReservationArrhes).mGetTable().id_table,
                            id: dataReservationArrhes.id_reservation_arrhes,
                            onValidePaiement: function (amount100, paiementIntent) {
                                jaugeDemarrage.mShow()
                                isPayed = true
                                window.setTimeout(function () {
                                    jaugeDemarrage.mShow()
                                    window.setTimeout(function () { jaugeDemarrage.mShow() }, 200)
                                }, 0)
                                dataReservationArrhes.id_mode_reglement_demande = idModeReglement
                                dataReservationArrhes.date_demande = parametre.dateNow
                                dataReservationArrhes.date_reglement = parametre.dateNow
                                option.dataForResa.dataReservation.id_statut_resa = 2

                                option.bddCtrl.mAjaxCall({
                                    command: "sendemailmessageclient",
                                    adresse_email: option.dataForResa.clDataSaisie.data.adresse_email,
                                    keyparasignature: "hebergement_modele_email_information_reservation_confirm_reglement_arrhes",
                                    html_complement_body: option.bddCtrl.getObjet(option.dataForResa.dataReservation).objetMetier.mGetElementRecapitulatif().prop("outerHTML")
                                }, function (data) {
                                })

                                option.dataForResa.dataReservationArrhes = dataReservationArrhes
                                jaugeDemarrage.mHide()
                                option.onNext()
                            }
                        }).dxCtrlPageSaisieCb("instance")
                        break;
                    default:
                        option.bddCtrl.mAjaxCall({
                            command: "savereglementarrhesetvalidestatutreservation",
                            id_reservation: option.dataForResa.dataReservation.id_reservation,
                            id_statut_resa: 1,
                            id_reservation_arrhes: dataReservationArrhes.id_reservation_arrhes,
                            id_mode_reglement: idModeReglement,
                            adresse_email: option.dataForResa.clDataSaisie.data.adresse_email,
                            keyparasignature: "hebergement_modele_email_information_reservation_avec_attente_arrhes",
                            html_complement_body: option.bddCtrl.getObjet(option.dataForResa.dataReservation).objetMetier.mGetElementRecapitulatif().prop("outerHTML")
                        }, function (data) {
                            isPayed = true
                            dataReservationArrhes.id_mode_reglement_demande = idModeReglement
                            dataReservationArrhes.date_demande = parametre.dateNow
                            option.dataForResa.dataReservation.id_statut_resa = 1
                            option.dataForResa.dataReservationArrhes = dataReservationArrhes
                            jaugeDemarrage.mHide()
                            option.onNext()
                        })
                        break;
                }
            })
        }

    }

    this.mIsActivated = function () {
        mConstruit()
    }

    this.isOkForNext = function (dxScroll) {
        var okForNext = true

        if (!isPayed) {
            okForNext = false
            //$DivLstReg.css("border-left", "3px solid red")
            //$DivLstReg.addClass("jiggle").css("animation-duration", "0.12s");
            //window.setTimeout(function () { $DivLstReg.removeClass("jiggle").css("animation-duration", ""); }, 500)
            container.find(".linkconfirmreg").each(function (idx, ele) {
                $(ele).css("border-left", "3px solid red")
                $(ele).addClass("jiggle").css("animation-duration", "0.12s");
                window.setTimeout(function () { $(ele).removeClass("jiggle").css("animation-duration", ""); }, 500)
            })
            var firstElementScroll = $DivLstReg

            if (dxScroll && firstElementScroll) {
                window.setTimeout(function () {
                    dxScroll.smoothScrollToElement(firstElementScroll, 600, function () {
                    })
                }, 10)
            }

            mNotify("Veuillez Choisir votre mode de reglement et cliquer sur le lien de validation.", "warning", 6000)
        }


        return okForNext
    }

    this.mGetClassIconeForLstItem = function () {
        return "fas fa-credit-card"
    }
    this.hasHeight100Percent = function () { return true }
    this.title = function () { return "Votre règlement" }
    this.mGetProprieteImage = function () {
        var urlFond = ""
        var lstImage = JSON.parse(option.bddCtrl.paraAppli.mGetPara("hebergement_resa_internet_list_image_arriere_plan"))
        if (lstImage.length > 0) {
            var idxImage = Math.floor(Math.random() * lstImage.length)
            var urlFond = lstImage[idxImage]
        } else {
            var idxImage = Math.floor(Math.random() * 20) + 1;
            var urlFond = parametre.urldispatch + "/img/imglogin/" + parametre.baseAppli.code_appli_general + "/img" + idxImage + ".jpg"
        }
        return {
            url: urlFond,
            position: (parametre.isPhone ? "Gauche" : "Droite")
        }
    }

    this.mGetUrlLink = function () {
        //https://xxxxx.xxxxxx.eu/nom_base/id_page/reservation
        return parametre.url_appli.replace("app.", "appgo.") + "/" + option.bddCtrl.nom_base + "/" +
            "3/reservation"
    }

    this.mGetIndexFromUrlLink = function (locationPathname) {
        //https://xxxxx.xxxxxx.eu/nom_base/id_page/reservation
        //locationPathname=/nom_base/id_page/reservation
        return locationPathname.split("/")[2]
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();

}